import _dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ja';

_dayjs.extend(utc);
_dayjs.extend(timezone);
_dayjs.extend(localizedFormat);
_dayjs.locale('ja');
_dayjs.tz.setDefault('Asia/Tokyo');

export type dayjs = _dayjs.Dayjs;
export const dayjs = _dayjs;

// ex) '2024-11-20T12:40:50.123+09:00'
export const ISO8601 = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
